import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-array/src/zip.js
// module id = 75ci
// module chunks = 0